import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

import {useCurrentRouteMatchParams} from '../../../routes/utils';
import {isMountedInShell, useActiveProductId} from '../../../shellRemote';
import {type AriaPageScope, resolveAriaPageScope} from './resolveAriaPageScope';

/**
 * useAriaPageScope returns the entity and project ARIA works in on the current
 * page, resolved from the Forge product serving it and the route. Nothing
 * inside ARIA reads the W&B app's NavContext. The shell could later hand this
 * scope in directly.
 */
export function useAriaPageScope(): AriaPageScope {
  const activeProductId = useActiveProductId();
  const {pathname} = useLocation();
  const routeParams = useCurrentRouteMatchParams();
  return useMemo(
    () =>
      resolveAriaPageScope(
        activeProductId,
        pathname,
        routeParams,
        isMountedInShell()
      ),
    [activeProductId, pathname, routeParams]
  );
}
